import {useQuery} from "@tanstack/react-query";
import {getData} from "../../../app/getters/getData.js";


export const useConfigFiles = (url, initialData) => {
    return useQuery({
        queryKey: [`config_files`],
        initialData,
        queryFn: async () => getData(url),
        enabled: !initialData
    })
}